export default __webpack_public_path__ + "static/media/cross-request.2f3e3b08.svg";